import { useSelector } from 'react-redux'

export const useHasAccess = () => {
  const currentOccupation = useSelector(state => state.auth.currentOccupation)

  return permissionList => {
    if (!permissionList?.length) return false
    return permissionList.includes(String(currentOccupation))
  }
}
